import React from 'react';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

const DoughnutChart = (props) => {
    Chart.register(Title);

    return (
        <div>
            <Doughnut key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default DoughnutChart;
